import { type InsuranceCorporateIdentity } from "../types";

export function VerbundPlusLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M275.515 312.001H408.407V385.873H275.515V312.001Z"
        fill="url(#paint0_linear_31_4638)"
      />
      <path
        d="M275.515 118.137H358.377V200.999H275.515V118.137Z"
        fill="url(#paint1_linear_31_4638)"
      />
      <path
        d="M460 200.999H53.8999V311.611H460V200.999Z"
        fill="url(#paint2_linear_31_4638)"
      />
      <path
        d="M275.516 90.386V422.614H164.512V90.386H275.516Z"
        fill="url(#paint3_linear_31_4638)"
      />
      <path
        d="M164.512 200.999H275.516V312.002H164.512V200.999Z"
        fill="url(#paint4_linear_31_4638)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31_4638"
          x1="408.464"
          y1="348.793"
          x2="275.512"
          y2="348.793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9262B" />
          <stop offset="1" stopColor="#ED9100" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_31_4638"
          x1="353.733"
          y1="159.04"
          x2="270.624"
          y2="159.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD618" />
          <stop offset="1" stopColor="#E97C04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_31_4638"
          x1="53.846"
          y1="256.576"
          x2="460.091"
          y2="256.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF7D00" />
          <stop offset="1" stopColor="#BE1925" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_31_4638"
          x1="275.516"
          y1="256.5"
          x2="164.512"
          y2="256.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDF6B" />
          <stop offset="1" stopColor="#ED9100" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_31_4638"
          x1="275.516"
          y1="256.5"
          x2="164.512"
          y2="256.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB3944" />
          <stop offset="1" stopColor="#BE1925" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const VerbundPlus: InsuranceCorporateIdentity = {
  id: "verbund-plus",
  name: "VerbundPlus",
  logo: VerbundPlusLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "verbund",
  type: "statutory",
};
